import { genPageTheme } from '@backstage/theme';
import { essityBrand } from './colours';

// Plain header with no shape or gradient, so the title is always read against the header background.
export const createEssityPageTheme = (fontColor: string) => ({
  ...genPageTheme({
    colors: [essityBrand.navy],
    shape: '',
    options: { fontColor },
  }),
  backgroundImage: 'none',
});
